import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ListItemRadioButton,
  type ListItemRadioButtonProps,
} from '@wix/da-ds/pkg/List/ListItem';
import { type SubNavigation } from '../../../../../../types/store';
import s from './ShopFiltersSaleTypeRadioGroup.scss';

export interface Props extends Pick<ListItemRadioButtonProps, 'onChange'> {
  saleTypes: SubNavigation;
  currentFilterValue: string;
  className?: string;
}

const ShopFiltersSaleTypeRadioGroup: React.FC<Props> = ({
  className,
  saleTypes,
  currentFilterValue,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <fieldset className={className}>
      <legend className={s['group-title']}>
        {t('shopPage.shopFiltersForm.saleType.legend')}
      </legend>

      {saleTypes.options?.map(({ subnav }) => {
        return (
          <ListItemRadioButton
            key={`${subnav}-${currentFilterValue}`}
            className={s['radio-button']}
            name="saleType"
            label={t(`shopPage.shopFiltersForm.saleType.label.${subnav}`)}
            value={subnav}
            checked={subnav === currentFilterValue}
            onChange={onChange}
          />
        );
      })}
    </fieldset>
  );
};

ShopFiltersSaleTypeRadioGroup.displayName = 'ShopFiltersSaleTypeRadioGroup';
export default ShopFiltersSaleTypeRadioGroup;
